import React, { ReactElement } from 'react';
import SolutionLinkItem from '@components/solution-link-item';
import Text from '@components/ui/text';
import Grid from '../components/grid';
import IndexText from '@components/index-text';
import Container from '@components/ui/container';
import { ASSET_URL } from 'lib/constants';

export default function TrioLinkCTA(block: any): ReactElement {
  const { links, title, video } = block;
  return (
    <Container>
      <Grid className="bg-black relative p-8 md:p-12 lg:p-20 overflow-hidden">
        <div className="z-10 col-span-full flex flex-col justify-start items-start">
          <IndexText index={'WHY TELESOFT'} type="text" />
          <Text
            variant="subHeading"
            className="text-white mb-10 leading-relaxed max-w-4xl"
          >
            {title}
          </Text>
        </div>
        {links.map(({ link }: any, i: number) => {
          return (
            <SolutionLinkItem
              key={`callout-link-map--${i}`}
              order={`0${i + 1}`}
              link={link}
            />
          );
        })}
        <div className="z-10 absolute inset-0 bg-gradient-to-b from-telesoft to-transparent mix-blend-soft-light" />
        <div className="absolute inset-0 opacity-25">
          <video
            id="vid"
            loop
            autoPlay
            width="100%"
            className="z-10 object-cover"
            playsInline
            muted
            height="100%"
          >
            <source
              src={
                video?.filename
                  ? ASSET_URL + '/' + video.filename
                  : `/assets/video/home-test.mp4`
              }
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </Grid>
    </Container>
  );
}
